import React from 'react'
import styles from './About.module.css'
import { HoverState } from '../../../assets/utils/cursorTypes'
import Box from './Boxes/Box';
import { FaPython, FaReact, FaHtml5, FaCss3Alt, FaJava } from 'react-icons/fa';
import { TbBrandCSharp, TbBrandReactNative, TbSql } from "react-icons/tb";
import { SiMysql, SiLua, SiTypescript } from "react-icons/si";
import { IoLogoJavascript } from "react-icons/io5";
import IconComponent from '../../IconComponent/IconComponent';
import { color } from 'framer-motion';

export type AboutProps = {
    setHoverElement: React.Dispatch<React.SetStateAction<HoverState>>;
}


const About = (props: AboutProps) => {   

    const handleMouseEnter = () => props.setHoverElement('pointer');
    const handleMouseLeave = () => props.setHoverElement('normal');   
    
    const items = [
        {
            icon: FaPython,
            color: '#306998'
        },
        {
            icon: TbBrandCSharp,
            color: '#239120'
        },
        {
            icon: FaCss3Alt,
            color: '#2965f1'
        },
        {
            icon: FaReact,
            color: '#61dafb'
        },
        {
            icon: SiMysql,
            color: '#4479A1'
        },
        {
            icon: SiTypescript,
            color: '#3178C6'
        },
        {
            icon: TbBrandReactNative,
            color: '#61dafb'
        },
        {
            icon: TbSql,
            color: '#F4B800'
        },
        {
            icon: FaHtml5,
            color: '#e34f26'
        },
        {
            icon: FaJava,
            color: '#f8981d'
        },
        {
            icon: SiLua,
            color: '#2c2d72'
        },
        {
            icon: IoLogoJavascript,
            color: '#f7df1e'
        },
    ];
    

    return (
        <div className={styles.container}>
            <div className={styles.info}>
                <div className={styles.info_desc}>Driven by a passion for technology, creating intuitive digital solutions that simplify lives and enrich user experiences.</div>
                    <div className={styles.circle_wrapper}>
                        <div className={styles.circle_p}>
                            {items.map((item, i) => {
                                const itemAngle = (360 / items.length) * i;
                                return (
                                    <div
                                        key={i}
                                        className={styles.p_l_item}
                                        style={{ "--angle": `${itemAngle}deg`, "--color-p-l": item.color } as React.CSSProperties}
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <IconComponent icon={item.icon} size={30} />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
            </div>
            <div className={styles.info}>
                <div className={styles.info_desc2}>Completed a professional course in Computer Systems Management and Programming, and currently pursuing a degree in Computer Engineering. This journey has built a strong technical foundation, enabling me to design digital solutions that combine functionality with user-centered design to improve everyday experiences.</div>
                <div className={styles.boxes}>
                    <Box setHoverElement={props.setHoverElement} title='<p>frontend_dev</p>' backgroundImage='code_frontend.png' />
                    <Box setHoverElement={props.setHoverElement} title='./backend dev ( )' backgroundImage='code_backend.png' />
                    <Box setHoverElement={props.setHoverElement} title='designer :)' backgroundImage='designer.png' />
                </div>
            </div>
        </div>
    )
}

export default About;
